import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  TIME_INTERVALS,
  TIME_INTERVALS_LATEST,
} from "@follaw-fr/constants/time-interval";
import {
  getDateLongFormat,
  getDateTimeHourFormat,
  getMonthYearFormat,
  toParis,
} from "@follaw-fr/utils/formatDate";
import { capitalizeFirstLetter } from "@follaw-fr/utils/helper.utils";

dayjs.extend(utc);

export function getStartDateFromPreset(preset) {
  switch (preset) {
    case TIME_INTERVALS_LATEST.LAST_24H:
      return dayjs().subtract(1, "day").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LAST_WEEK:
      return dayjs().subtract(1, "week").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LAST_MONTH:
      return dayjs().subtract(1, "month").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LAST_YEAR:
      return dayjs().subtract(1, "year").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LEGI_15:
      return dayjs("2017-06-27T00:00:00+02:00").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LEGI_16:
      return dayjs("2022-06-28T00:00:00+02:00").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LEGI_17:
      return dayjs("2024-07-18T00:00:00+02:00").format("YYYY-MM-DD");
  }

  return dayjs().format("YYYY-MM-DD");
}

export function getEndDateFromPreset(preset) {
  switch (preset) {
    case TIME_INTERVALS_LATEST.LEGI_15:
      return dayjs("2022-06-21T00:00:00+02:00").format("YYYY-MM-DD");
    case TIME_INTERVALS_LATEST.LEGI_16:
      return dayjs("2024-06-10T00:00:00+02:00").format("YYYY-MM-DD");
  }

  return undefined;
}

/**
 * Les buckets du date_histogram OpenSearch sont calculés en UTC : la clé d'un
 * point de la courbe est un début d'heure / de jour / de mois UTC. Borner la
 * plage en heure locale décalerait le top 10 de l'offset du navigateur (2 h en
 * été à Paris) par rapport au point cliqué.
 */
export const getIsoDateRange = (isoDate, interval) => {
  const dateTime = dayjs.utc(isoDate);

  return {
    start: dateTime.startOf(interval).toISOString(),
    end: dateTime.endOf(interval).toISOString(),
  };
};

export const getFormattedDate = (isoDate, interval) => {
  const formatMap = {
    [TIME_INTERVALS.MONTH]: "MMMM YYYY",
    [TIME_INTERVALS.HOUR]: "HH:mm",
    [TIME_INTERVALS.DAY]: "DD/MM/YYYY",
  };

  const format = formatMap[interval] || formatMap[TIME_INTERVALS.DAY];
  const formattedDate = toParis(isoDate).format(format);

  return formattedDate;
};

/**
 * Libellé du panneau de zoom d'une courbe temporelle. Il suit l'intervalle de
 * la courbe : à l'heure, la date seule laisserait croire que le panneau couvre
 * la journée entière.
 */
export const getTimeCurveZoomTitle = ({ count, date, interval }) => {
  const top = `Top ${Math.min(count ?? 0, 10)}`;

  if (interval === TIME_INTERVALS.MONTH) {
    return `${top} de ${capitalizeFirstLetter(getMonthYearFormat(date))} :`;
  }

  if (interval === TIME_INTERVALS.HOUR) {
    return `${top} du ${getDateTimeHourFormat(date)} :`;
  }

  return `${top} du ${getDateLongFormat(date)} :`;
};
